export default {
  manual: {
    // ========================================
    // Common: Shared across multiple pages
    // ========================================
    common: {
      notice_no_speech: "音声が検出されなかったため、書き起こしとタイトルは作成していません。",
      notice_title_undetermined: "書き起こしから作業内容を読み取れなかったため、タイトルはファイル名のままです。",
      loading: "読み込み中...",
      defaultManualTitle: "マニュアル詳細",
      defaultVideoTitle: "作業マニュアル",
      defaultDocumentTitle: "ドキュメント",
      defaultPublicManualTitle: "マニュアル",
      defaultPublicVideoTitle: "動画マニュアル",

      // Status maps (manual)
      statusPending: "処理待ち",
      statusTranscribing: "書き起こし中",
      statusExtractingFrames: "静止画抽出中",
      statusCompleted: "完了",
      statusFailed: "失敗",

      // Status maps (document)
      documentStatusPending: "ドキュメント未生成",
      documentStatusGenerating: "ドキュメント生成中",
      documentStatusCompleted: "ドキュメント完了",
      documentStatusFailed: "ドキュメント生成失敗",

      // Video status labels (ManualVideo getStatusLabel)
      statusLabelPending: "待機中...",
      statusLabelTranscribing: "音声を書き起こし中...",
      statusLabelExtractingFrames: "静止画を抽出中...",
      statusLabelCompleted: "完了",
      statusLabelFailed: "失敗",

      // List status labels (ManualList getStatusLabel)
      listStatusPending: "待機中",
      listStatusTranscribing: "書き起こし中",
      listStatusExtractingFrames: "静止画抽出中",
      listStatusCompleted: "完了",
      listStatusFailed: "失敗",

      // Tooltips
      editTitle: "タイトルを編集",
      editSummary: "概要を編集",
      editFileName: "ファイル名を編集",

      // Section headings
      summary: "概要",
      requiredItems: "必要なもの",
      stepList: "手順一覧",

      // Language
      language: "言語:",
      sourceLanguageSuffix: "（原語）",
      addTranslation: "翻訳を追加",
      allLanguagesTranslated: "すべての言語に翻訳済み",

      // Language names (Japanese)
      langJa: "日本語",
      langEn: "英語",
      langZh: "中国語",
      langKo: "韓国語",
      langEs: "スペイン語",
      langFr: "フランス語",
      langDe: "ドイツ語",
      langPt: "ポルトガル語",
      langVi: "ベトナム語",
      langTh: "タイ語",
      langId: "インドネシア語",

      // Meta
      createdAt: "作成日:",
      owner: "所有者:",

      // Duration
      durationFormat: "{mins}分{secs}秒",

      // Mode cards
      viewAsVideo: "動画で見る",
      viewAsVideoDescription: "動画を再生しながら手順を確認",
      viewAsDocument: "ドキュメントで見る",
      viewAsDocumentDescription: "A4形式で表示・PDF出力・印刷",

      // Error messages
      errorFetchManual: "マニュアルの取得に失敗しました。",
      errorFetchData: "データの取得に失敗しました。",
      errorFetchDocument: "ドキュメントの取得に失敗しました。",
      errorPublicNotFound: "マニュアルが見つからないか、公開されていません。",
      errorPublicDocumentNotFound: "ドキュメントが見つかりません。URLが正しいか確認してください。",
    },

    // ========================================
    // ManualDetail.vue
    // ========================================
    detail: {
      generatePreview: "プレビューを生成",
      analyzeScenesBeta: "映像解析（試験中）",
      // Public settings
      publicOn: "公開中",
      publicOff: "非公開",
      copyUrl: "URLコピー",
      qrCodeDescription: "このQRコードをスキャンすると、マニュアルにアクセスできます。",
      downloadQrCode: "QRコードをダウンロード",
      passwordLock: "パスワードでロック",
      passwordLabel: "パスワード: {password}",
      copyTooltip: "コピー",
      regenerateTooltip: "再生成",

      // Translation dialog
      translating: "翻訳中...",
      translatingTo: "{language}に翻訳しています",
      segmentCount: "{count}セグメント",
      translationTimingNote: "セグメント数によっては数十秒かかることがあります",

      // Translation delete confirm
      deleteTranslationTitle: "の翻訳",
      deleteTranslationQuestion: "を削除しますか？",
      deleteTranslationMessage: "セグメントとドキュメントの翻訳が削除されます。",
      deleteTranslationMessageInProgress: "進行中の翻訳処理を中止し、この言語の状態をリセットします。あとで再実行できます。",

      // Toast messages
      toastPublicEnabled: "マニュアルを公開しました",
      toastPublicDisabled: "マニュアルの公開を解除しました",
      toastPublicToggleFailed: "公開設定の変更に失敗しました",
      toastUrlCopied: "URLをコピーしました",
      regenerateUrl: "URLを再発行",
      regenerateUrlTitle: "公開URLを再発行しますか？",
      regenerateUrlBody: "新しいURLを発行します。これまでのURLとQRコードはすぐに使えなくなります。配布済みの場合は、新しいURLを配り直してください。",
      toastUrlRegenerated: "公開URLを再発行しました",
      toastUrlRegenerateFailed: "公開URLの再発行に失敗しました",
      toastCopyFailed: "コピーに失敗しました",
      toastPasswordEnabled: "パスワードロックを有効にしました",
      toastPasswordDisabled: "パスワードロックを解除しました",
      toastPasswordToggleFailed: "パスワード設定の変更に失敗しました",
      toastPasswordRegenerated: "パスワードを再生成しました",
      toastPasswordRegenerateFailed: "パスワードの再生成に失敗しました",
      toastPasswordCopied: "パスワードをコピーしました",
      toastQrDownloaded: "QRコードをダウンロードしました",
      toastQrNotFound: "QRコードが見つかりません",
      toastQrConvertFailed: "QRコードの変換に失敗しました",
      toastTitleUpdated: "タイトルを更新しました",
      toastTitleUpdateFailed: "タイトルの更新に失敗しました",
      toastSummaryUpdated: "概要を更新しました",
      toastSummaryUpdateFailed: "概要の更新に失敗しました",
      toastTranslationComplete: "{language}への翻訳が完了しました",
      toastTranslationPartial: "{language}への翻訳が完了しましたが、{total}件中{translated}件のみ翻訳されました",
      toastTranslationFailed: "翻訳に失敗しました",
      toastTranslationStarted: "{language}への翻訳を開始しました",
      toastTranslationAlreadyInProgress: "{language}への翻訳は既に進行中です",
      translatingBadge: "翻訳中…",
      toastTranslationDeleted: "翻訳を削除しました",
      toastTranslationDeleteFailed: "翻訳の削除に失敗しました",

      // Digest video
      generateDigestTooltip: "ダイジェスト動画を作成",
      regenerateDigestTooltip: "ダイジェスト動画を再生成",
      digestGenerating: "ダイジェスト生成中...",
      toastDigestStarted: "ダイジェスト動画の生成を開始しました",
      toastDigestFailed: "ダイジェスト動画の生成開始に失敗しました",

      // Retranscription
      changeSourceLanguageTooltip: "原語を指定して書き起こし直す",
      retranscribeAutoDetect: "自動検出",
      retranscribeTitle: "原語を{lang}として書き起こし直しますか？",
      retranscribeTitleAuto: "原語を自動検出して書き起こし直しますか？",
      retranscribeBody: "動画全体を書き起こし直します。セグメントの編集内容・生成済みドキュメント・ダイジェスト動画は失われ、作り直しになります。タイトルとライブラリ上のファイル名も自動で付け直されます。",
      retranscribeLoseTranslations: "翻訳（{langs}）も削除されます。",
      retranscribeConfirm: "書き起こし直す",
      retranscribeCancel: "キャンセル",
      retranscribeStarted: "再書き起こしを開始しました",
      retranscribeFailed: "再書き起こしの開始に失敗しました",
      retranscribeBusy: "ドキュメントやダイジェストなどの生成処理が進行中です。完了してからもう一度お試しください。",
    },

    // ========================================
    // ManualVideo.vue
    // ========================================
    video: {
      toastSegmentSyncPending: "直前の操作を保存しています。少し待ってからもう一度お試しください",
      // Header
      exportButton: "書き出し（試験中）",

      // Processing state
      pleaseWait: "処理が完了するまでお待ちください...",
      manualGenerationFailed: "マニュアル生成に失敗しました。",

      // Preview/normalize banner (HEVC 等の自動変換状態)
      // docs/engineering/MANUAL_VIDEO_NORMALIZATION_PLAN.md §5.4
      previewBannerConverting: "このブラウザは HEVC の再生に対応していません。動画を変換中ですので、少しお待ちください。",
      previewBannerCompleted: "動画の変換が終わりました。ページを再読み込みしてください。",
      previewBannerFailed: "動画の変換に失敗しました。サポートにご連絡ください。",

      // Scene 解析タブ (Gemini 映像解析)
      // docs/engineering/MANUAL_VIDEO_SCENE_ANALYSIS_PLAN.md §6.4
      tabTranscript: "書き起こし",
      tabScenes: "シーン解析",
      sceneAnalysisRunning: "映像解析中です。終わると一覧が表示されます",
      sceneAnalysisRunningShort: "映像解析中",
      digestGenerating: "ダイジェスト動画作成中",
      sceneAnalysisAwaitingPreview: "動画を変換してから映像解析を実行します",
      sceneAnalysisFailed: "映像解析に失敗しました。再解析を試してください。",
      sceneAnalysisNotStarted: "まだ映像解析を実行していません。下のボタンで開始できます。",
      sceneAnalysisNotAvailable: "preview の準備が完了してから実行できます。",
      sceneCutBoundary: "カット直後",
      sceneConfidence: "確信度",
      sceneObjects: "検出物",
      sceneTags: "タグ",
      analyzeScenes: "映像解析を実行",
      regenerateScenes: "映像解析をやり直す",
      sceneAnalyzing: "解析中…",
      sceneAnalysisStarted: "映像解析を開始しました（完了まで数分）",
      sceneAnalysisStartFailed: "映像解析の開始に失敗しました。",

      // Segment list
      segmentListTitle: "セグメント一覧",
      noSegments: "セグメントがありません",
      segmentCountLabel: "{count} セグメント",
      stereoVideoLabel: "ステレオ動画",
      thumbnailLoading: "読込中",
      editedBadge: "編集済み",
      imageEditTooltip: "画像を編集",

      // Video controls
      playbackSpeed: "再生速度",
      speedNormal: "標準",
      splitSegmentTooltip: "現在の位置でセグメントを分割",
      theaterModeTooltip: "シアターモード",
      subtitleToggleTooltip: "字幕表示切替",
      stereoLeft: "左",
      stereoRight: "右",
      stereoBoth: "両",
      noTranscript: "（書き起こしなし）",

      // Download
      downloadVideo: "動画をダウンロード",
      downloadLeftEye: "左目のみダウンロード",
      downloadRightEye: "右目のみダウンロード",
      downloadPreparing: "ダウンロードの準備中...",
      downloadFileSizeNote: "ファイルサイズによって時間がかかる場合があります",
      downloadFailed: "動画のダウンロードに失敗しました",

      // Stereo convert
      stereoConverting: "ステレオ動画を変換中...",
      stereoConvertDefault: "ステレオ動画を変換しています...",
      stereoConvertProcessing: "処理中...",
      stereoConvertQueued: "変換の順番を待っています...",
      stereoConvertPercent: "変換中... {percent}%",
      stereoConvertFailed: "動画の変換に失敗しました",
      cancel: "キャンセル",

      // Export dialog
      exportDialogTitle: "動画を書き出し",
      exportStarting: "書き出しを開始しています...",
      exportQueueWaiting: "キューで待機中...",
      exportProcessingSegment: "セグメント処理中: {current}/{total}",
      exportMerging: "クリップを結合中...",
      exportFinalizing: "字幕を焼き込み中...",
      exportProcessing: "動画を書き出し中...",
      exportBurningSubtitles: "非表示区間をカットし、字幕を焼き込んでいます...",
      exportSegmentsCompleted: "{current} / {total} セグメントが完了",
      exportCompleted: "書き出しが完了しました",
      exportFailed: "書き出しに失敗しました",
      exportUnknownError: "不明なエラーが発生しました",
      exportStartFailed: "書き出しの開始に失敗しました",
      download: "ダウンロード",
      close: "閉じる",

      // Help modal
      helpTitle: "動画マニュアルの使い方",
      helpVideoPlayback: "動画再生",
      helpVideoPlaybackItem1: "動画を再生すると、現在位置に対応するセグメントが自動でハイライトされます",
      helpVideoPlaybackItem2: "セグメントカードをクリックすると、その開始位置にジャンプします",
      helpTranscriptEdit: "書き起こし編集",
      helpTranscriptEditItem1: "テキストエリアをクリックするとその位置に動画がシークします",
      helpTranscriptEditItem2: "Enterキーでセグメントを分割（カーソル位置で前後に分かれます）",
      helpTranscriptEditItem3: "先頭でBackspaceキーを押すと前のセグメントとマージされます",
      helpThumbnail: "サムネイル画像",
      helpThumbnailItem1: "サムネイルをクリックすると拡大表示されます",
      helpThumbnailItem2: "拡大モーダルでは画像の非表示設定やマーク追加ができます",
      helpThumbnailItem3: "ペンツールで手書き、円ツールで円マークを追加できます",
      helpThumbnailItem4: "マークをクリックすると削除できます",
      helpThumbnailItem5: "モーダルを閉じると自動で保存されます",
      helpStereo: "ステレオ動画",
      helpStereoItem1: "ステレオ動画の場合、右上に「左/右/両」のトグルが表示されます",
      helpStereoItem2: "「左」「右」で片目だけ、「両」で両目同時に表示できます",

      // 合成音声（TTS）— UI 上は「TTS」を出さず「合成音声」で統一
      ttsCreateButton: "合成音声を作成",
      ttsSettingsTooltip: "合成音声の設定",
      ttsPlaybackOn: "合成音声で再生中（クリックで原音）",
      ttsPlaybackOff: "原音で再生中（クリックで合成音声）",
      ttsModalTitle: "合成音声で読み上げ",
      ttsVoiceLabel: "声を選ぶ",
      ttsVoiceHint: "サンプルを再生して選んでください",
      ttsVoiceChangedNote: "声を変更しました。次回生成時にこの声が使用されます。既存の言語は作り直しが必要です。",
      ttsLanguagesTitle: "言語ごとの合成音声",
      ttsSourceLangBadge: "原語",
      ttsGenerate: "作成",
      ttsRegenerate: "作り直す",
      ttsGenerating: "作成中…",
      ttsStatusCompleted: "作成済み",
      ttsStatusGenerating: "作成中（数十秒〜数分かかります）",
      ttsStatusFailed: "作成失敗",
      ttsStatusNone: "未作成",
      ttsGenerateFailed: "合成音声の作成開始に失敗しました",
    },

    // 言語ラベル（i18n と独立）
    languages: {
      ja: "日本語",
      en: "英語",
      zh: "中国語",
      ko: "韓国語",
      es: "スペイン語",
      pt: "ポルトガル語",
      vi: "ベトナム語",
      th: "タイ語",
      id: "インドネシア語",
    },

    // ========================================
    // ManualDocument.vue
    // ========================================
    document: {
      // Buttons
      regenerate: "再生成",
      print: "印刷",
      undoTooltip: "元に戻す (Ctrl+Z)",
      redoTooltip: "やり直し (Ctrl+Shift+Z)",

      // Scene-augmented regeneration (docs/engineering/MANUAL_VIDEO_SCENE_ANALYSIS_PLAN.md §5.3)
      regenerateDialogTitle: "ドキュメントを再生成",
      regenerateDialogDescription: "情報源を選んでください。",
      regenerateOptionTranscriptOnly: "書き起こしのみ (従来通り)",
      regenerateOptionTranscriptOnlyDesc: "Whisper の書き起こしテキストのみを使ってドキュメントを構成します。",
      regenerateOptionWithScenes: "書き起こし + 映像解析 (推奨)",
      regenerateOptionWithScenesDesc: "Gemini で抽出したシーン情報と Whisper 発話を統合してドキュメントを構成します。",
      regenerateOptionScenesOnly: "映像解析のみ",
      regenerateOptionScenesOnlyDesc: "音声を無視し、映像から抽出したシーン情報のみで構成します（無音動画 / 低品質な書き起こし時のリカバリ用）。",
      regenerateConfirm: "再生成",
      regenerateCancel: "キャンセル",
      regenerateSceneAnalysisRequired: "「映像解析」モードは scene 解析が完了している必要があります。",

      // Document status
      generatingDocument: "ドキュメント生成中...",
      generatingAiMessage: "AIがマニュアルを構成しています。しばらくお待ちください...",
      documentNotGenerated: "ドキュメントがまだ生成されていません",
      documentNotGeneratedAction: "ボタンを押してドキュメントを生成してください",
      generateDocument: "ドキュメントを生成",
      documentWaiting: "ドキュメント生成待機中",
      documentWaitingMessage: "マニュアル完了後に自動で生成されます",
      documentGenerationFailed: "ドキュメント生成に失敗しました。",

      // Section labels (Japanese)
      sectionPurpose: "目的",
      sectionRequiredItems: "必要な物品",
      sectionSteps: "手順",
      sectionCaution: "注意事項",

      // Editing
      requiredItemsPlaceholder: "1行に1つずつ入力",
      cautionPlaceholder: "1行に1つずつ入力",
      noItems: "（項目なし）",
      restorePreviousValue: "手動編集した値に戻す",
      restorePreviousSteps: "再生成前の手順に戻す",
      regenerateOverwriteNotice: "タイトルと概要は、手動で編集していれば保持されます。目的・必要なもの・注意事項・手順は新しい内容に置き換わります。手動で編集していた項目は、再生成後に「手動編集した値に戻す」で戻せます。",
      toastRegenerateInProgress: "ドキュメントはすでに再生成中です。完了までお待ちください",
      imagePreviewTitle: "画像プレビュー",
      hiddenImageTooltip: "非表示の画像（クリックで表示）",

      // Toast messages
      toastRegenerateStarted: "ドキュメント再生成を開始しました",
      toastRegenerateFailed: "ドキュメント再生成に失敗しました",
      toastSaved: "保存しました",
      toastSaveFailed: "保存に失敗しました",
      toastRestoredPrevious: "手動編集した値に戻しました",
      toastRestoreFailed: "復元に失敗しました",
      toastUndone: "元に戻しました",
      toastUndoFailed: "元に戻す操作に失敗しました",
      toastRedone: "やり直しました",
      toastRedoFailed: "やり直し操作に失敗しました",
      toastWordDownloaded: "Wordファイルをダウンロードしました",
      toastWordFailed: "Word生成に失敗しました",
      toastPdfDownloaded: "PDFをダウンロードしました",
      toastPdfFailed: "PDF生成に失敗しました",

      // Help modal
      helpTitle: "ドキュメントマニュアルの使い方",
      helpAboutDocument: "ドキュメントとは",
      helpAboutDocumentItem1: "動画の書き起こしからAIが自動で作業マニュアルを構成します",
      helpAboutDocumentItem2: "目的、必要物品、手順、注意事項、まとめが自動生成されます",
      helpTextEdit: "テキスト編集",
      helpTextEditItem1: "テキスト部分をクリックすると編集モードになります",
      helpTextEditItem2: "編集後、フォーカスを外すと自動保存されます",
      helpTextEditItem3: "手動編集した箇所は「再生成」しても上書きされません",
      helpImage: "画像の操作",
      helpImageItem1: "画像をクリックすると拡大表示されます",
      helpImageItem2: "拡大モーダルでは画像の非表示設定やマーク追加ができます",
      helpImageItem3: "動画モードで追加したマークもドキュメントに反映されます",
      helpRegenerate: "再生成",
      helpRegenerateItem1: "「再生成」ボタンで最新の書き起こしからドキュメントを作り直せます",
      helpRegenerateItem2: "手動編集した箇所は保持され、編集していない箇所のみ更新されます",
      helpDownload: "ダウンロード",
      helpDownloadItem1: "「PDF」「Word」ボタンでドキュメントをダウンロードできます",
      helpDownloadItem2: "「印刷」ボタンでブラウザの印刷ダイアログを開きます",
      close: "閉じる",
    },

    // ========================================
    // ManualList.vue
    // ========================================
    list: {
      // Header
      pageTitle: "作業マニュアル",

      // Upload area
      uploadTitle: "動画をアップロード",
      uploadDescription: "クリックまたはファイルをドラッグ＆ドロップ",
      uploadFormats: "対応形式: MP4, WebM, MOV",

      // Drop overlay
      dropOverlayText: "ここに動画ファイルをドロップ",
      dropOverlayFormats: "対応形式: MP4, WebM, MOV",

      // Search
      searchPlaceholder: "ファイル名・本文・タグで検索",
      moreMatches: "他 {n} 件",

      // Sort options
      sortManual: "手動順",
      sortNewest: "新しい順",
      sortOldest: "古い順",
      sortUpdated: "更新順",
      sortName: "名前順",

      // View mode tooltips
      gridView: "グリッド表示",
      listView: "リスト表示",

      // Empty states
      noRooms: "マニュアル対象のルームがありません。",
      noFilesInRoom: "このルームにはまだファイルがありません。",

      // Auto tags
      tagAll: "すべて",
      tagUntagged: "未分類",
      tagManageTooltip: "タグ管理",
      tagExpandChips: "タグを開く",
      tagCollapseChips: "タグを閉じる",

      // Status
      notGenerated: "未生成",

      // Tooltips
      documentTooltip: "ドキュメント",
      regenerateTooltip: "再生成",
      generateTooltip: "マニュアル生成",
      downloadVideoTooltip: "動画をダウンロード",
      deleteFileTooltip: "ファイルを削除",

      // Deleting
      deletingOverlay: "削除中...",

      // Trash section
      trashTitle: "ゴミ箱 ({count})",
      trashAutoDeleteMessage: "30日後に完全に削除されます",

      // Delete confirm
      deleteConfirmSuffix: "を削除しますか？",
      deleteConfirmMessage: "ゴミ箱に移動されます。30日後に完全に削除されます。",

      // Bulk operations
      bulkSelect: "一括選択",
      selectionModeOff: "選択モードOFF",
      selectAll: "全選択",
      bulkDelete: "削除",
      bulkDeleteConfirmTitle: "{count}件のファイルを削除しますか？",
      bulkDeleteConfirmMessage: "選択したファイルがゴミ箱に移動されます。30日後に完全に削除されます。",

      // Download overlay
      downloadPreparing: "ダウンロードの準備中...",
      downloadFileSizeNote: "ファイルサイズによって時間がかかる場合があります",

      // Room select dialog
      selectRoomTitle: "アップロード先のルームを選択",
      roomLabel: "ルーム",
      cancelButton: "キャンセル",
      uploadButton: "アップロード",

      // Toast messages
      toastEditAfterGeneration: "マニュアル生成後にタイトルを編集できます",
      toastSelectVideoFiles: "動画ファイルを選択してください（MP4, WebM, MOV）",
      toastNonVideoExcluded: "動画ファイル以外は除外されました",
      toastUploadSuccess: "{count}件の動画をアップロードしました",
      toastUploadCancelled: "アップロードがキャンセルされました",
      toastUploadFailed: "アップロードに失敗しました",
      noSearchResults: "「{query}」に一致するマニュアルはありません",
      toastEmptyFileSkipped: "空のファイル（0 バイト）は送信しませんでした: {names}",
      toastRegisterFailed: "登録できなかったファイルがあります: {names}",
      toastRestored: "マニュアルを復元しました",
      toastRestoreFailed: "復元に失敗しました。時間をおいて再度お試しください",

      // Error messages
      errorFetchData: "データの取得に失敗しました。",
      errorStartGeneration: "マニュアル生成の開始に失敗しました。",
      errorRegenerate: "マニュアルの再生成に失敗しました。",
      errorVideoUrlFetch: "動画URLの取得に失敗しました。",
      errorVideoDownload: "動画のダウンロードに失敗しました。",
      errorTitleUpdate: "タイトルの更新に失敗しました。",
      errorFileDelete: "ファイルの削除に失敗しました。",
    },

    // ========================================
    // Public pages (PublicManualDetail, PublicManualVideo, PublicManualDocument)
    // ========================================
    public: {
      // Password gate
      passwordRequired: "パスワードが必要です",
      passwordPrompt: "{title}を閲覧するにはパスワードを入力してください",
      passwordPromptDefault: "このマニュアルを閲覧するにはパスワードを入力してください",
      passwordLabel: "パスワード",
      passwordSubmit: "確認",
      passwordIncorrect: "パスワードが正しくありません",
      passwordError: "エラーが発生しました",
      rateLimited: "アクセスが集中しています。しばらく待ってから再度お試しください。",
      passwordRateLimited: "入力回数の上限に達しました。1分ほど待ってから再度お試しください。",

      // Public video
      manualNotReady: "このマニュアルはまだ準備中です。",
      publicStepList: "手順一覧",

      // Public document sections
      sectionPurpose: "目的",
      sectionRequiredItems: "必要な物品",
      sectionSteps: "手順",
      sectionCaution: "注意事項",

      // Toast (public document)
      toastPdfDownloaded: "PDFをダウンロードしました",
      toastPdfFailed: "PDF生成に失敗しました",
    },

    // ========================================
    // ImageEnlargeModal.vue
    // ========================================
    imageModal: {
      // Header
      defaultTitle: "画像プレビュー",

      // Visibility toggle
      showImage: "表示",
      hideImage: "非表示",

      // Tool tooltips
      moveTool: "移動",
      penTool: "手書きペン",
      circleTool: "円マーク",
      colorTooltip: "マークの色",
      deleteAllTooltip: "全削除",
      undoTooltip: "元に戻す (Ctrl+Z)",
      redoTooltip: "やり直し (Ctrl+Shift+Z)",
      cancelTooltip: "キャンセル",
      resetZoomTooltip: "等倍に戻す",

      // Hints
      hintHand: "スクロールでズーム / ドラッグで移動",
      hintCircle: "ドラッグで円を描画 / 円をクリックで削除",
      hintPen: "ドラッグして手書き / 線をクリックで削除",
      viewerHint: "スクロールでズーム / ドラッグで移動",

      // Save button
      save: "保存",
    },

    // ========================================
    // Auto tags（タグ管理ダイアログ + Manual 詳細のタグ表示）
    // ========================================
    tags: {
      dialogTitle: "タグ管理",
      tagsInputLabel: "タグ (Enter で追加、× で削除)",
      tooManyTags: "タグは {max} 件までです",
      saveFailed: "タグの保存に失敗しました",
      orphanLabel: "未登録のまま使われているタグ (クリックで追加):",
      aiSuggestButton: "AI に新規タグを提案させる",
      aiSuggestionsLabel: "AI 提案 (クリックで追加):",
      statsLine: "未分類: {untagged} 件 / 全 {total} 件",
      reset: "リセット",
      close: "閉じる",
      save: "保存",
      manualEditLabel: "タグを編集",
      manualEditDone: "保存",
      manualEditCancel: "キャンセル",
      manualUnlock: "ロック解除（AI に再分類させる）",
      autoTagsLabel: "自動分類",
      manualTagsLabel: "手動",
      noTaxonomy: "タグ未設定",
    },
  },
};
